<template>
  <div id="messages-feed">

    <div class="row">
      <div class="col-12">
        <form @submit="searchMessage" class="search-form mt-2 pr-3">
          <div class="input-group">
            <input v-model="searchQuery" id="feed-search" class="input-search" placeholder="Nachrichten durchsuchen" name="search-message" type="text">
            <div class="input-group-btn">

              <button v-if="!searchResults" class="btn btn-search" :disabled="processing" type="submit">
                <clip-loader :loading="processing" :color="'white'" :size="'18px'"></clip-loader>
                <img v-if="!processing" src="~assets/img/search.png" class="icon-search"/>
              </button>

              <button v-if="searchResults" @click="clearSearch" class="btn btn-search" type="button">
                <clip-loader :loading="processing" :color="'white'" :size="'18px'"></clip-loader>
                <img v-if="!processing" src="~assets/img/search_close.png" class="icon-search"/>
              </button>

            </div>
          </div>
        </form>

      </div>
    </div>

    <div class="row row-tabs">
      <div class="col-12">
        <b-tabs>
          <b-tab title="Offen" active @click="infiniteHandler">
            <div v-if="banner.detailresponse">
              <a class="feed-tile banner-tile" :class="user.parent === true ? 'parent-banner' : 'teacher-banner'">
                <h5 class="tile-addressee"><twemoji :content="banner.detailresponse.title"/></h5>
                <p><twemoji :content="banner.detailresponse.text"/></p>
                <button type="button" aria-label="Close" class="close" @click="readBanner(banner.detailresponse.banner_id)">×</button>
              </a>
            </div>
            <div v-for="message in opened_messages" >
              <feed-tile :message="message"/>
            </div>
            <clip-loader :loading="processing" :color="'grey'" :size="'32px'"></clip-loader>
            <infinite-loading  @infinite="infiniteHandler" ref="infiniteLoading" v-if="enableInfinite">
              <div slot="no-results"></div>
              <div slot="spinner"><clip-loader :loading="true" :color="'grey'" :size="'32px'"></clip-loader></div>
              <div slot="no-more">Keine weiteren Nachrichten.</div>
            </infinite-loading>
            <div v-if="opened_messages.length === 0 && processing === false" class="empty-feed text-center mt-3">
              {{ emptyOpenedMessagesListMsg }}
            </div>
          </b-tab>
          <b-tab title="Erledigt" @click="infiniteHandlerClosedMessages">
            <div v-for="message in closed_messages">
              <feed-tile :message="message"/>
            </div>
            <clip-loader :loading="processing" :color="'grey'" :size="'32px'"></clip-loader>
            <infinite-loading @infinite="infiniteHandlerClosedMessages"  ref="infiniteLoadingClosed"  v-if="enableInfiniteClosed">
              <div slot="no-results"></div>
              <div slot="spinner"><clip-loader :loading="true" :color="'grey'" :size="'32px'"></clip-loader></div>
              <div slot="no-more">Keine weiteren Nachrichten.</div>
            </infinite-loading>
            <div v-if="closed_messages.length === 0  && processing === false" class="empty-feed text-center mt-3">
              {{ emptyClosedMessagesListMsg }}
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>

  </div>
</template>

<script>
// API
import feedApi from '@/api/v1/messages';
// Components
import FeedTile from '@/components/Messages/Feed/Tile';
import InfiniteLoading from 'vue-infinite-loading';

let refreshMessageFeed = 0;
var firstTime = 0;

export default {
  name: 'Feed',
  components: { FeedTile, 'infinite-loading': InfiniteLoading },

  data() {
    return {
      opened_messages: [],
      closed_messages: [],
      emptyOpenedMessagesListMsg: '',
      emptyClosedMessagesListMsg: '',
      searchQuery: '',
      searchResults: false,
      processing: false,
      numberOpen: 10,
      numberClosed: 10,
      pagingresults: 10,
      activeTab: 'open',
      busyOpen: false,
      busyClosed: false,
      enableInfinite: false,
      enableInfiniteClosed: false,
      banner: [],
      user: this.$current_user,
    };
  },
  methods: {
    getFeedList() {
      const vm = this;
      if(vm.activeTab === 'open') {
        var refreshMessagesLength = this.opened_messages.length > 10 ? this.opened_messages.length : 10;
        feedApi.index((data) => {
          if (data.statuscode === 70) {
            this.$router.push({name: 'user_deactivated'});
            return;
          }
          vm.opened_messages = data.listresponse || [];
          vm.processing = false;
          if(this.searchQuery){
            vm.emptyOpenedMessagesListMsg = 'Zu Ihrer Eingabe konnten keine Suchergebnisse gefunden werden.';
          }
          else {
            vm.emptyOpenedMessagesListMsg = 'Sie haben noch keine Nachrichten erstellt oder erhalten.';
          }
          if(vm.opened_messages.length < 10){
            this.enableInfinite = false;
          }
          else {
            this.enableInfinite = true;
          }
          if (vm.opened_messages[0]) {
            const firstMessageId = vm.opened_messages[0].itemid;
            if (vm.$router.history.current.name === 'home') {
              vm.$router.push({name: 'show_message', params: {id: firstMessageId}});
            }
          }
        }, {search: this.searchQuery, closed: false, pagingresults: refreshMessagesLength});
      }
      else {
       var refreshMessagesLength = this.closed_messages.length > 10 ? this.closed_messages.length : 10;
        feedApi.index((data) => {
          if (data.statuscode === 70) {
            this.$router.push({name: 'user_deactivated'});
            return;
          }

          vm.closed_messages = data.listresponse || [];
          vm.processing = false;
          if(this.searchQuery){
            vm.emptyClosedMessagesListMsg = 'Zu Ihrer Eingabe konnten keine Suchergebnisse gefunden werden.';
          }
          else {
            vm.emptyClosedMessagesListMsg = 'Sie haben keine erledigten Nachrichten.';
          }
          if(vm.closed_messages.length < 10){
            this.enableInfiniteClosed = false;
          }
          else {
            this.enableInfiniteClosed = true;
          }
        }, {search: this.searchQuery, closed: true, pagingresults: refreshMessagesLength});
      }
      this.$bus.refreshUnreadedNo();
    },
    infiniteHandler($state) {
      this.activeTab = 'open';
      if(this.busyOpen === false) {
        this.busyOpen = true;
        const vm = this;
        if (!$state) {
          this.processing = true;
          this.getFeedList();
          this.busyOpen = false;
          return;
        }
        setTimeout(() => {
          feedApi.index((data) => {
            if (data.statuscode === 70) {
              this.$router.push({name: 'user_deactivated'});
              return;
            }
            if (!data.listresponse[0]) {
              $state.complete();
            } else {
              var i;
              for (i = 0; i < data.listresponse.length; i++) {
                vm.opened_messages.push(data.listresponse[i]);
              }
              this.numberOpen = this.numberOpen + 10;
              this.busyOpen = false;
              vm.processing = false;
              vm.emptyOpenedMessagesListMsg = 'Sie haben noch keine Nachrichten erstellt oder erhalten.';

              if($state) {
                $state.loaded();
              };
            }
          }, {search: this.searchQuery, closed: false, pagingindex: this.numberOpen, pagingresults: this.pagingresults});
        }, 100);
      }
    },
    infiniteHandlerClosedMessages($state) {
      this.activeTab = 'closed';
      if(this.busyClosed === false) {
        this.busyClosed = true;
        const vm = this;
        if (!$state) {
          this.processing = true;
          this.getFeedList();
          this.busyClosed = false;
          return;
        }
        setTimeout(() => {
          feedApi.index((data) => {
            if (data.statuscode === 70) {
              this.$router.push({name: 'user_deactivated'});
              return;
            }
            if (!data.listresponse[0]) {
              if ($state) {
                $state.complete();
              }
            } else {
              var i;
              for (i = 0; i < data.listresponse.length; i++) {
                vm.closed_messages.push(data.listresponse[i]);
              }
              this.numberClosed = this.numberClosed + 10;
              this.busyClosed = false;
              vm.processing = false;
              vm.emptyOpenedMessagesListMsg = 'Sie haben noch keine Nachrichten erstellt oder erhalten.';
              if ($state) {
                $state.loaded();
              }
            }
          }, {search: this.searchQuery, closed: true, pagingindex: this.numberClosed, pagingresults: this.pagingresults});

        }, 100);
      }
    },
    searchMessage() {
      event.preventDefault();
      this.enableInfinite = false;
      this.enableInfiniteClosed = false;
      this.processing = true;
      this.searchResults = true;
      this.opened_messages = [];
      this.closed_messages = [];
      this.numberOpen = 10;
      this.numberClosed = 10;
      this.busyOpen = false;
      this.busyClosed = false;
      if(this.$refs.infiniteLoading){
        this.$refs.infiniteLoading.stateChanger.reset();
      }
      if(this.$refs.infiniteLoadingClosed){
        this.$refs.infiniteLoadingClosed.stateChanger.reset();
      }
      this.getFeedList();
    },
    clearSearch() {
      this.processing = true;
      this.searchResults = false;
      this.enableInfinite = false;
      this.enableInfiniteClosed = false;
      this.searchQuery = '';
      this.opened_messages = [];
      this.closed_messages = [];
      this.numberOpen = 10;
      this.busyOpen = false;
      this.busyClosed = false;
      this.numberClosed = 10;
      if(this.$refs.infiniteLoading){
        this.$refs.infiniteLoading.stateChanger.reset();
      }
      if(this.$refs.infiniteLoadingClosed){
        this.$refs.infiniteLoadingClosed.stateChanger.reset();
      }
      this.getFeedList();

    },
    readBanner(id) {
      feedApi.readBanner((data) => {
        this.banner = [];
      }, { bannerid: id });
    },
  },
  created() {
    // this.getFeedList();
    refreshMessageFeed = setInterval(() => { this.getFeedList(); }, 60000);
  },
  mounted() {
    const vm = this;
    if(firstTime === 0) {
      firstTime = 1;
      this.$bus.$on('feed:refresh', () => {
        vm.getFeedList();
      });
     }
    feedApi.getBanner((data) => {
        this.banner = data;
    });
  },
  beforeDestroy() {
    clearInterval(refreshMessageFeed);
  },
  watch: {
    $route(to, from) {
      if (to.name === 'home' || from.name === 'new_message') {
        this.getFeedList();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Messages/Feed/Index.vue